export default "__VITE_PUBLIC_ASSET__33c17cf2__"